/* global axios */
// TOOLS-03 — ligar e desligar uma tool do catálogo num agente.
//
// O agente só enxerga uma tool por VÍNCULO. Sem estas rotas, publicar uma tool nativa nova
// terminava num INSERT à mão — que foi de onde nasceu o DEFEITO-VINCULO-APONTA-V2-E-SERVE-V1
// (vínculo criado sem `version_spec`, servindo a v1 com `problemas: []`).
//
// Tool de TEMPLATE entrou aqui em TOOLS-05, com o filtro ESTREITADO e não removido: ela aparece em
// `disponiveis` só quando a conta já tem a instância — aí a config da loja existe e ligar uma a uma
// é seguro. Vínculo sem instância continua impossível, e o banco reforça
// (`tool_catalog_entries_forma_ck` exige `instance_id` em template).
//
// Por que virou necessário: cada tool ligada viaja na descrição do agente em TODO turno. Levar as
// quatro de um fornecedor quando o agente usa duas é custo fixo por conversa.
const BASE = accountId => `/api/v1/accounts/${accountId}/tool_bindings`;

const body = r => r.data;

export default {
  // Devolve o que está ligado (`payload`) E o que pode ser ligado (`disponiveis`) — as duas listas
  // no mesmo instante, senão a tela desenha um seletor com o que já foi ligado.
  index(accountId, agentSlug) {
    return axios
      .get(BASE(accountId), { params: { agent_slug: agentSlug } })
      .then(body);
  },

  // `version_spec` omitido → o servidor põe `latest`. Fixar número é decisão de quem opera
  // (congelar o agente numa versão), não um default.
  create(accountId, agentSlug, entryId, versionSpec) {
    return axios
      .post(BASE(accountId), {
        agent_slug: agentSlug,
        tool_catalog_entry_id: entryId,
        version_spec: versionSpec,
      })
      .then(body);
  },

  update(accountId, id, attrs) {
    return axios.patch(`${BASE(accountId)}/${id}`, attrs).then(body);
  },

  destroy(accountId, id) {
    return axios.delete(`${BASE(accountId)}/${id}`).then(body);
  },
};
